module.exports = __webpack_public_path__ + "img/a10fd57.png";